module.exports = __webpack_public_path__ + "static/img/4.499b4821.png";